import { render, staticRenderFns } from "./taskSkillPoint.vue?vue&type=template&id=6d66c29f&scoped=true&"
import script from "./taskSkillPoint.vue?vue&type=script&lang=js&"
export * from "./taskSkillPoint.vue?vue&type=script&lang=js&"
import style0 from "./taskSkillPoint.vue?vue&type=style&index=0&id=6d66c29f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66c29f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d66c29f')) {
      api.createRecord('6d66c29f', component.options)
    } else {
      api.reload('6d66c29f', component.options)
    }
    module.hot.accept("./taskSkillPoint.vue?vue&type=template&id=6d66c29f&scoped=true&", function () {
      api.rerender('6d66c29f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkillPoint.vue"
export default component.exports